import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule } from '@angular/forms';
import { TablerIconsModule } from 'angular-tabler-icons';
import { TranslateModule } from '@ngx-translate/core';
import { AllowOnlyDigitsDirective } from 'src/app/common/directive/allow-only-digits.directive';
import { IPatientContact, IPatientInfo } from '../../ipatient-info';

@Component({
  selector: 'app-contact-detail',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    TablerIconsModule,
    TranslateModule,
    AllowOnlyDigitsDirective
  ],
  templateUrl: './contact-detail.component.html',
  styleUrl: './contact-detail.component.scss'
})
export class ContactDetailComponent implements OnInit, OnChanges {


  @Input() patient: IPatientInfo;

  ngOnInit(): void {
    if (!this.patient.contactInfo || this.patient.contactInfo.length === 0) {
      this.patient.contactInfo = [this.createEmptyContact()];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['patient'] && this.patient) {
      if (!this.patient.contactInfo || this.patient.contactInfo.length === 0) {
        this.patient.contactInfo = [this.createEmptyContact()];
      }
    }
  }
  createEmptyContact(): IPatientContact {
    return {
      id: 0,
      contact: '',
      phone: '',
      email: '',
      // fax: '',
      // alternativeno: '',
      isDefault: true
    };

  }
}
